import './index.css';
import { useEffect, useState } from 'react';
import { View, Text } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import { BsArrowDownShort, BsArrowUpShort } from 'react-icons/bs';
import I18n from '../../../utilities/locale';
import React from 'react';

interface Props {
  defenderList?: any;
  allRounderList?: any;
  raiderList?: any;
  sortName?: string;
  sortType?: string;
  onUpdateSortingList?: any;
}
const TeamSortingKabaddi = ({
  defenderList,
  allRounderList,
  raiderList,
  sortName,
  sortType,
  onUpdateSortingList
}: Props) => {
  const { FantasyTheme: theme } = useTheme();
  const [players, setPlayers] = useState('' as any); //UP or DOWN
  const [points, setPoints] = useState('' as any); //UP or DOWN
  const [credit, setCredit] = useState('' as any); //UP or DOWN

  useEffect(() => {
    setPlayers(sortName === 'PLAYERS' ? sortType : '');
    setPoints(sortName === 'POINTS' ? sortType : '');
    setCredit(sortName === 'CREDITS' ? sortType : '');
  }, []);

  const sortByName = (type: string, playerList: any[]) => {
    if (type === 'DOWN')
      return playerList.sort(function (a: { shortName: number }, b: { shortName: number }) {
        if (a.shortName < b.shortName) {
          return -1;
        }
        if (a.shortName > b.shortName) {
          return 1;
        }
        return 0;
      });
    else
      return playerList.sort(function (a: { shortName: number }, b: { shortName: number }) {
        if (a.shortName > b.shortName) {
          return -1;
        }
        if (a.shortName < b.shortName) {
          return 1;
        }
        return 0;
      });
  };

  const sortByPoint = (type: string, playerList: any[]) => {
    if (type === 'DOWN')
      return playerList.sort(
        (a: { totalpoints: number }, b: { totalpoints: number }) => a.totalpoints - b.totalpoints
      );
    else
      return playerList.sort(
        (a: { totalpoints: number }, b: { totalpoints: number }) => b.totalpoints - a.totalpoints
      );
  };

  const sortByCredit = (type: string, playerList: any[]) => {
    if (type === 'DOWN')
      return playerList.sort((a: { rating: number }, b: { rating: number }) => a.rating - b.rating);
    else
      return playerList.sort((a: { rating: number }, b: { rating: number }) => b.rating - a.rating);
  };

  const onClickPlayers = async () => {
    const latestValue = players === '' ? 'DOWN' : players === 'DOWN' ? 'UP' : 'DOWN';
    setPlayers(latestValue);
    setCredit('');
    setPoints('');

    const updateDefenderList = sortByName(latestValue, defenderList);
    const updateRounderList = sortByName(latestValue, allRounderList);
    const updateRaiderList = sortByName(latestValue, raiderList);

    onUpdateSortingList({
      defenderList: updateDefenderList,
      allRounderList: updateRounderList,
      raiderList: updateRaiderList,
      sortType: 'PLAYERS',
      sortName: latestValue
    });
  };

  const onClickPoints = async () => {
    const latestValue = points === '' ? 'DOWN' : points === 'DOWN' ? 'UP' : 'DOWN';
    setPoints(latestValue);
    setPlayers('');
    setCredit('');

    const updateDefenderList = sortByPoint(latestValue, defenderList);
    const updateRounderList = sortByPoint(latestValue, allRounderList);
    const updateRaiderList = sortByPoint(latestValue, raiderList);

    onUpdateSortingList({
      defenderList: updateDefenderList,
      allRounderList: updateRounderList,
      raiderList: updateRaiderList,
      sortType: 'POINTS',
      sortName: latestValue
    });
  };

  const onClickCredits = async () => {
    const latestValue = credit === '' ? 'DOWN' : credit === 'DOWN' ? 'UP' : 'DOWN';
    setCredit(latestValue);
    setPlayers('');
    setPoints('');

    const updateDefenderList = sortByCredit(latestValue, defenderList);
    const updateRounderList = sortByCredit(latestValue, allRounderList);
    const updateRaiderList = sortByCredit(latestValue, raiderList);

    onUpdateSortingList({
      defenderList: updateDefenderList,
      allRounderList: updateRounderList,
      raiderList: updateRaiderList,
      sortType: 'CREDITS',
      sortName: latestValue
    });
  };

  const onClickTeamName = () => {};

  const upIcon = () => {
    return (
      <View className={'team-sorting-icon'}>
        <BsArrowUpShort name={'arrow-up'} size={18} fill={theme.TeamSortingKabaddiIcon} />
      </View>
    );
  };

  const downIcon = () => {
    return (
      <View className={'team-sorting-icon'}>
        <BsArrowDownShort name={'arrow-down'} size={18} fill={theme.TeamSortingKabaddiIcon} />
      </View>
    );
  };

  const sortingTextColor = {
    color: theme.teamSortingText
  };

  return (
    <View className={'team-sorting-container'}>
      <View className={'team-sorting-icon-wrapper'} style={{ flex: 2 }} onPress={onClickPlayers}>
        <Text className={'team-sorting-title'} style={sortingTextColor}>
          {I18n.t('Players')}
        </Text>
        {players != '' && players === 'UP' ? upIcon() : downIcon()}
      </View>
      <View className={'team-sorting-icon-wrapper'} style={{ flex: 1 }} onPress={onClickPoints}>
        <Text className={'team-sorting-title'} style={sortingTextColor}>
          {I18n.t('Points')}
        </Text>
        {points != '' && points === 'UP' ? upIcon() : downIcon()}
      </View>
      <View className={'team-sorting-icon-wrapper'} style={{ flex: 1 }} onPress={onClickCredits}>
        <Text className={'team-sorting-title'} style={sortingTextColor}>
          {I18n.t('Credits')}
        </Text>
        {credit != '' && credit === 'UP' ? upIcon() : downIcon()}
      </View>
      <View className={'team-sorting-title'} style={{ flex: 1 }} onPress={onClickTeamName} />
    </View>
  );
};
export default React.memo(TeamSortingKabaddi);
